<template>
    <div
        class="a-icon"
        :style="[
            width || size ? { width: cssWidth } : {},
            height || size ? { height: cssHeight } : {},
            color ? { color } : {}
        ]"
        :class="iconClass"
    >
        <component :is="`Icon${icon}`" v-bind="iconBindings" />
    </div>
</template>

<script>
import Vue from 'vue'
import { primitiveBindings } from '@/helpers/attr-value'

const requireComponent = require.context('../icons', false, /[\w]+\.vue$/)

// register each component
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    const Comp = componentConfig.default || componentConfig
    const componentName = `Icon${fileName
        .substr(0, fileName.length - 4)
        .substr(2)}`
    Vue.component(componentName, {
        extends: Comp,
        inheritAttrs: false
    })
})

export default {
    name: 'AIcon',
    props: {
        iconConfig: {
            type: Object,
            default: () => ({})
        },
        icon: {
            type: String,
            required: true
        },
        iconClass: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false
        },
        size: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        }
    },
    computed: {
        cssWidth() {
            const width = this.width || this.size
            if (!width) return undefined
            return /px$|em$|rem$|%$|vw$|vh$/.test(width) ? width : width + 'px'
        },
        cssHeight() {
            const height = this.height || this.size
            if (!height) return undefined
            return /px$|em$|rem$|%$|vw$|vh$/.test(height) ? height : height + 'px'
        },
        iconBindings() {
            return primitiveBindings(this.iconConfig)
        }
    }
}
</script>
